import { ParsedReportParams, ReportBackendTypes } from '@ais-ui/websockets';
import { CustomizeDensity } from './CustomizeDensity';
import { CustomizeTrack } from './CustomizeTrack';
import { CustomizeMultiShape } from './CustomizeMultiShape';
import { CustomizePassageline } from './CustomizePassageline';
import { CustomizeSpeedOverGround } from './CustomizeSpeedOverGround';
import { CustomizeCoverage } from './CustomizeCoverage';
import { CustomizePassagelineShips } from './CustomizePassagelineShips';
import React from 'react';

interface CustomizeProps {
  reportType: string | null;
  report: ParsedReportParams | null;
  className?: string;
}

export const CustomizeReport = React.memo(
  ({ reportType, report, className }: CustomizeProps) => {
    if (!reportType || !report) {
      return null;
    }

    switch (reportType) {
      case ReportBackendTypes.DENSITY:
        return <CustomizeDensity report={report} className={className} />;
      case ReportBackendTypes.TRACK:
        return <CustomizeTrack report={report} className={className} />;
      case ReportBackendTypes.MULTI_SHAPE:
        return <CustomizeMultiShape report={report} className={className} />;
      case ReportBackendTypes.PASSAGELINE:
        return <CustomizePassageline report={report} className={className} />;
      case ReportBackendTypes.SOG_DISTRIBUTION:
        return (
          <CustomizeSpeedOverGround report={report} className={className} />
        );
      case ReportBackendTypes.COVERAGE:
        return <CustomizeCoverage report={report} className={className} />;
      case ReportBackendTypes.PASSAGELINE_SHIPS:
        return (
          <CustomizePassagelineShips report={report} className={className} />
        );
      default:
        return null;
    }
  },
);

CustomizeReport.displayName = 'CustomizeReport';
